import React, { useEffect, useState } from 'react';
import IconFont from '@/components/icon-font';
import styles from './index.module.css';

interface IModal {
  children: React.ReactNode;
  visible: boolean;
  // eslint-disable-next-line
  onClose?: Function;
  width?: number | string;
  style?: React.CSSProperties;
}
const Modal = (props: IModal) => {
  const { children, visible = false, onClose, width, style } = props;
  const [show, setShow] = useState(visible);

  const handleClose = () => {
    onClose && onClose();
    setShow(false);
  };

  useEffect(() => {
    document.documentElement.style.overflow = visible ? 'hidden' : 'initial';
    setShow(visible);
  }, [visible]);

  const modalStyles: React.CSSProperties = style || {};
  if (width) {
    modalStyles.width = width;
  }
  return show ? (
    <div className={styles.wrap}>
      <div
        className={styles.modal}
        style={{
          ...modalStyles,
        }}
      >
        <div className={styles.content}>
          <div className={styles.close} onClick={() => handleClose()}>
            <IconFont name="crossBold" fontSize={24}></IconFont>
          </div>
          {children}
        </div>
      </div>
    </div>
  ) : null;
};

export default Modal;
